import { ActionType, EntityType, ModuleType } from "../../queryKeyFactory";

export const outstandingKeyFactory = {
    // ================================
    // OUTSTANDING BILLS LIST
    // ================================
    list: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "outstanding",
        "list",
        filters,
    ],
    exportList: (filters?: any): [ModuleType, EntityType, ActionType, any?] => [
        "cx",
        "outstanding",
        "outstandingExport",
        filters,
    ],
    summary: (remoteUtilityId: number): [ModuleType, EntityType, ActionType, number] => [
        "cx",
        "outstanding",
        "summary",
        remoteUtilityId,
    ],
    createPaymentAgreement: (remoteUtilityId: number, remoteBillId: number): [ModuleType, EntityType, ActionType, number, number] => [
        "cx",
        "outstanding",
        "create",
        remoteUtilityId,
        remoteBillId,
    ],
    paymentAgreementDetail: (remoteUtilityId: number, remoteBillId: number): [ModuleType, EntityType, ActionType, number, number] => [   
        "cx",
        "outstanding",
        "paymentAgreementDetail",
        remoteUtilityId,
        remoteBillId,
    ],
    paymentAgreements: (remoteUtilityId: number, remoteBillId: number): [ModuleType, EntityType, ActionType, number, number] => [
        "cx",
        "outstanding",
        "paymentAgreements",
        remoteUtilityId,
        remoteBillId,
    ],
    getPaymentAgreementDetail: (remoteUtilityId: number, remoteBillId: number): [ModuleType, EntityType, ActionType, number, number] => [
        "cx",
        "outstanding",
        "details",
        remoteUtilityId,
        remoteBillId,
    ],
    
    accountDetails: (accountId: string): [ModuleType, EntityType, ActionType, string] => [
        "cx",
        "outstanding",
        "details",
        accountId,
    ],
    
}